import SweetAlert from './SweetAlert.js';
var Swal = SweetAlert;
Swal.default = Swal;
export default Swal;